import { SubmitHandler, useForm } from "react-hook-form";
import axiosInstance from "services/axiosInstance";
import * as S from "./styled";
//hooks
import apiRequest from "../../../../hooks/apiRequest";
import useLoading from '../../../../hooks/useLoading';
import { usePasswordToggle } from "../../../../hooks/usePasswordToggle";
//Components
import { useEffect } from "react";
import LayoutModal from "../../../LayoutModal";
import Loading from "../../../Loading";
//Icons
import { Eye, EyeSlash } from "@phosphor-icons/react";
import { ICreate } from "Interfaces/ICreate";
import { Inputs } from "Interfaces/IUser";
export default function Update({
  isOpenModal,
  setModalClose,
  refreshFrames,
  selectedUrlId,
  setToastData,
  setToastOpen
}: ICreate) {
  const {
    register,
    handleSubmit: handleFormSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm<Inputs>();

  const { inputType, icon, togglePasswordVisibility } = usePasswordToggle();
  const { isLoading, startLoading, stopLoading } = useLoading();
  const {
    isLoading: isLoadingSubmit,
    startLoading: startLoadingSubmit,
    stopLoading: stopLoadingSubmit
  } = useLoading();

  const fetchData = async () => {
    startLoading();
    try {
      const response = await axiosInstance.get(`user/${selectedUrlId}`);

      const addressData = response.data;
      for (const key in addressData) {
        setValue(key as keyof Inputs, addressData[key]);
      }
    } catch (error) {
      console.log("Error: ", error);
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    if (isOpenModal && selectedUrlId !== null) {
      fetchData();
    }
  }, [isOpenModal, selectedUrlId]);

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    startLoadingSubmit();
    try {
      const payload = {
        ...data,
        first_name: data.first_name.toLocaleUpperCase(),
        last_name: data.last_name.toLocaleUpperCase(),
      }
      const response = await apiRequest(`user/${selectedUrlId}`, 'PATCH', payload);
      const status = response.status;
      if (status === 200) {
        setToastData({
          status: status,
          message: 'Cadastrado com sucesso!',
        });

        setToastOpen(true);
        refreshFrames();
        setModalClose();
      }
    } catch (error: any) {
      setToastData({
        status: error?.response?.status || 500,
        message: error.message || 'Erro inesperado',
      });

      setToastOpen(true);
    } finally {
      stopLoadingSubmit();
    }
  };

  if (isOpenModal) {
    return (
      <LayoutModal
        statusLoad={isLoadingSubmit}
        title="Editar Usuário"
        subTitle="Atualize informações do usuário em sua base de dados."
        setModalClose={setModalClose}
        submiteModal={handleFormSubmit(onSubmit)}
        nameSubmit="Atualizar"
      >
        {isLoading ? (
          <Loading />
        ) : (
          <S.Container>
            <S.SeparateDiv>
              <S.FormInput>
                <S.Label>
                  Nome do Usuário
                  <span>*</span>
                </S.Label>
                <S.Input
                  placeholder="Informe o nome"
                  type="text"
                  {...register("first_name", { required: true })}
                />
                {errors.first_name && (
                  <S.InforErro>Campo Obrigatório</S.InforErro>
                )}
              </S.FormInput>

              <S.FormInput>
                <S.Label>
                  Sobrenome
                  <span>*</span>
                </S.Label>
                <S.Input
                  placeholder="Informe o sobrenome"
                  type="text"
                  {...register("last_name", { required: true })}
                />
                {errors.last_name && <S.InforErro>Campo Obrigatório</S.InforErro>}
              </S.FormInput>
            </S.SeparateDiv>

            <S.FormInput>
              <S.Label>
                E-mail <span>*</span>
              </S.Label>
              <S.Input
                placeholder="exemplo@gmail.com"
                type="email"
                {...register("email", { required: true })}
              />
              {errors.email && <S.InforErro>Campo Obrigatório</S.InforErro>}
            </S.FormInput>

            <S.SeparateDiv>
              <S.FormInput>
                <S.Label>
                  Senha
                </S.Label>
                <S.ContentInput>
                  <S.InputUnstyled
                    {...register("password")}
                    type={inputType}
                    placeholder="Informe sua senha"
                  />

                  <S.ButtonOpenPassword
                    type="button"
                    onClick={togglePasswordVisibility}
                  >
                    {icon === "eye-open" ? (
                      <Eye size={20} />
                    ) : (
                      <EyeSlash size={20} />
                    )}
                  </S.ButtonOpenPassword>
                </S.ContentInput>
              </S.FormInput>

              <S.FormInput>
                <S.Label>
                  Confirmar Senha
                </S.Label>
                <S.ContentInput>
                  <S.InputUnstyled
                    {...register("password_confirmation")}
                    type={inputType}
                    placeholder="Confirme sua senha"
                  />

                  <S.ButtonOpenPassword
                    type="button"
                    onClick={togglePasswordVisibility}
                  >
                    {icon === "eye-open" ? (
                      <Eye size={20} />
                    ) : (
                      <EyeSlash size={20} />
                    )}
                  </S.ButtonOpenPassword>
                </S.ContentInput>
              </S.FormInput>
            </S.SeparateDiv>

            <S.FormInput>
              <S.Label>
                Tipo de Usuário
                <span>*</span>
              </S.Label>

              <S.ContentCheckbox>
                <S.CheckBox type="checkbox" id="is_admin"  {...register('is_admin', {
                  setValueAs: (value) => value ? 1 : 0
                })} />
                <S.Label htmlFor="is_admin">
                  Administrador
                </S.Label>
              </S.ContentCheckbox>

              <S.ContentCheckbox>
                <S.CheckBox type="checkbox" id="is_manager" {...register('is_manager', {
                  setValueAs: (value) => value ? 1 : 0
                })} />
                <S.Label htmlFor="is_manager">
                  Gerente
                </S.Label>
              </S.ContentCheckbox>
              {errors.is_admin && <S.InforErro>Campo Obrigatório</S.InforErro>}
            </S.FormInput>
          </S.Container>
        )}
      </LayoutModal>
    );
  }
  return null;
}
